import { styler, tween } from 'popmotion'
import { sceneMap } from '@/util/sceneMap'
import { mapState } from 'vuex'

export default {
    props: {
        element: {
            required: true,
            validator: o => o instanceof Element
        },
        sceneId: {
            required: false,
            type: String,
            validator: s => sceneMap.has(s) || s === '',
            default: ''
        }
    },

    computed: {
        ...mapState(['scene']),

        isCurrentScene() {
            if (Boolean(this.sceneId)) {
                return this.sceneId === this.scene
            } else {
                return true
            }
        },

        opacity() {
            return this.isCurrentScene ? { opacity: 1 } : { opacity: 0 }
        },
        styler() {
            return styler(this.element)
        },
        styles() {
            return ['opacity']
        },
        stylesObject() {
            return Object.assign({}, ...this.styles.map(style => this[style]))
        },
        _stylesObject() {
            return this.stylesObject
        }
    },

    watch: {
        _stylesObject: {
            immediate: true,
            handler: 'transition'
        }
    },

    // The transition is split so that each or all parts
    // of the transition can be replaced in the component.
    // By putting it in methods I can alter the action /
    // reaction based off the to / from values.
    // If the action / reaction was always going to be the same
    // I could put it in computed
    methods: {
        action(to, from) {
            return tween({ to, from })
        },
        reaction(to, from) {
            return this.styler.set
        },
        transition(to, from) {
            if (!Boolean(from)) {
                this.reaction(to, from)(to)
            } else {
                this.action(to, from).start(this.reaction(to, from))
            }
        }
    },

    render: () => null
}
